import { useContext } from 'react';

import { UserManagementListModalContext } from './user-management-list-modal-provider';

function useUserManagementListModal() {
  const context = useContext(UserManagementListModalContext);

  if (!context) {
    throw new Error(
      'useUserManagementListModal must be used within a UserManagementListModalProvider',
    );
  }

  return context;
}

export { useUserManagementListModal };
